var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconObPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 15.774,
    cy: 15.774,
    r: 15.774,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 90.498,
    y1: -292.763,
    x2: 90.498,
    y2: -292.88,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce852e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad5f3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 17.361,
    cy: 17.361,
    r: 17.361,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 22.758,
    cy: 22.758,
    r: 22.758,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ob-people",
    transform: "translate(-308 -969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(308 969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846",
    transform: "translate(320.083 978.526)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 17.746,
    cy: 17.746,
    r: 17.746,
    transform: "translate(43.917 20.755)",
    fill: "#f4d93b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 15.529,
    cy: 15.529,
    r: 15.529,
    transform: "translate(20.663 4.008)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2949",
    "data-name": "Group 2949",
    transform: "translate(15.733 6.02) rotate(-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    d: "M15.774,0A15.774,15.774,0,1,1,0,15.774,15.774,15.774,0,0,1,15.774,0Z",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2948",
    "data-name": "Group 2948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3599",
    "data-name": "Group 3599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2947",
    "data-name": "Group 2947",
    transform: "translate(5.54 3.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2946",
    "data-name": "Group 2946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M18.754.828h.013a10.58,10.58,0,0,0-4.091-.8L6.1,0A10.716,10.716,0,0,0,2.541,1a8.227,8.227,0,0,0-.983.489l-.049.022h.013C.562,2.076,0,2.739,0,3.448,0,5.558,4.861,7.267,10.859,7.267s10.858-1.71,10.858-3.819C21.716,2.43,20.586,1.516,18.754.828Z",
    transform: "translate(0 22.264)",
    fill: "#5e5e5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M.29,9.172A9.19,9.19,0,0,0,1.3,3.265C.631.241,9.028,0,9.028,0S7.54,7.828,9.8,9.651c0,0,1.777,1.75-1.393,2.411S-1.471,12.21.29,9.172Z",
    transform: "translate(5.572 13.58)",
    fill: "#dda77f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M.94,3.617C.7,5.3-1.683,12.045,2.215,11.932S8.978,9.058,10.23,9.822a2,2,0,0,0,3.063-1.536C13.606,6.626,17.1-.522,7.635.03,3.05.3,1.519-.442.94,3.617Z",
    transform: "translate(3.085 6.685)",
    fill: "#ecb98c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M.128,3.772A4.12,4.12,0,0,1,3.878,0,10.79,10.79,0,0,1,10.96,2.682,8.058,8.058,0,0,0,15.517,4.7a2.632,2.632,0,0,1,2.075,4.086c-.981,1.41-2.327,4.32-6.61,1.415S4.108,8.762,4.108,8.762-.849,10.471.128,3.772Z",
    transform: "translate(1.696)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2972",
    "data-name": "Group 2972",
    transform: "translate(47.517 16.23) rotate(14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2971",
    "data-name": "Group 2971"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 17.361,
    cy: 17.361,
    r: 17.361,
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2970",
    "data-name": "Group 2970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3606",
    "data-name": "Group 3606",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2969",
    "data-name": "Group 2969",
    transform: "translate(6.099 7.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2968",
    "data-name": "Group 2968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M12.522,21.376S-.355,23.335.008,21.3C3.242,13.063.556,8.652,1.185,3.134,1.7-1.461,9.659.353,9.659.353s.869.988,3.876,0,5.374.7,4.559,8.042c-.8,7.271-3.429,6.7,1.647,13.916C19.742,22.312,12.379,24.985,12.522,21.376Z",
    transform: "translate(2.091 0.913)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M20.643.91h.013a11.618,11.618,0,0,0-4.5-.882L6.719,0A11.786,11.786,0,0,0,2.8,1.095a9.331,9.331,0,0,0-1.082.539l-.056.024h.014C.617,2.285,0,3.014,0,3.8,0,6.118,5.352,8,11.95,8S23.9,6.118,23.9,3.8C23.9,2.673,22.655,1.661,20.643.91Z",
    transform: "translate(0 20.602)",
    fill: "#ffca55",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M.262,10.093a11.911,11.911,0,0,0,.914-6.5C.566.264,8.187,0,8.187,0s-1.351,8.614.7,10.621c0,0,1.617,1.927-1.265,2.655S-1.331,13.437.262,10.093Z",
    transform: "translate(7.125 11.045)",
    fill: "#9b6e50",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M.1,5.376C.312,7.231-.924,14.494,2.85,13.757s5.8-2.595,7.178-3.088a2.561,2.561,0,0,0,2.159-2.907C11.921,4.674,15.258-1.685,6.113.418,1.687,1.425-.522-.192.1,5.376Z",
    transform: "translate(5.169 3.813)",
    fill: "#b28562",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M.241,3.873A4.3,4.3,0,0,1,3.95.231c3.436-.623,4.516.147,5.6.722A8.858,8.858,0,0,0,14.455,2.2c2.5-.044,2.548,2.214,2.7,3.469.2,1.617-1.719,4.264-6.479,2.181s-5.652-.559-7.164-.4S-.844,8.071.241,3.873Z",
    transform: "translate(3.173)",
    fillRule: "evenodd"
  })))))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 22.746,
    cy: 22.746,
    r: 22.746,
    transform: "translate(0.917 32.501)",
    fill: "#88c4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826",
    transform: "translate(0 34.021) rotate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M0,22.759A22.7,22.7,0,0,0,7.72,39.841c5.688-.473,9.273,3.441,15.039,3.441,5.3,0,9.035-2.8,14.048-2.616A22.759,22.759,0,1,0,0,22.759Z",
    transform: "translate(0)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601",
    transform: "translate(6.191 6.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M4.273,1.2l-.018,0a15.256,15.256,0,0,1,5.9-1.164L22.523,0a15.382,15.382,0,0,1,5.14,1.435,11.908,11.908,0,0,1,1.42.707l.073.032h-.018c1.384.821,2.192,1.777,2.192,2.8,0,3.042-7.013,5.511-15.665,5.511S0,8.019,0,4.977C0,3.514,1.631,2.188,4.273,1.2Z",
    transform: "translate(0 30.6)",
    fill: "#5e5e5e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M14.433,13.232s-2.425-4.156-1.455-8.521S1.825,0,1.825,0,3.972,11.293.716,13.925c0,0-2.563,2.525,2.009,3.479S16.962,17.615,14.433,13.232Z",
    transform: "translate(8.451 18.08)",
    fill: "#aa7f61",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M19.1,5.219c.346,2.422,3.786,12.158-1.837,12S7.5,13.068,5.7,14.171s-3.966.178-4.418-2.217S-4.218-.751,9.444.044C16.054.429,18.263-.638,19.1,5.219Z",
    transform: "translate(6.427 8.132)",
    fill: "#c99877",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M25.838,3.927S25.363.31,20.425.049s-6.635.522-10.217,2.3C8.624,3.141,7.138,4.83,3.632,5.27a3.8,3.8,0,0,0-2.99,5.9C2.057,13.2,4,17.4,10.179,13.208S20.1,11.134,20.1,11.134,27.246,13.592,25.838,3.927Z",
    transform: "translate(2.863)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObPeople);
export default __webpack_public_path__ + "static/media/icon-ob-people.b4084cae74959f227b8ffdf3828b233c.svg";
export { ForwardRef as ReactComponent };